<template>
    <div class="bg-lightest mt-2">
        <div class="col-sm-12 py-4">
            <div class=" text-center dark pb-3" v-if="noTicketsSelected && !isPricePerGroupCategory">
                Empty pax
            </div>

            <table class="w-100 fs-small">
                <template v-if="!noTicketsSelected || totalExtras > 0 || isPricePerGroupCategory">
                    <tr>
                        <th></th>
                        <th class="text-right">Tax</th>
                        <th class="priceWidth text-right">Price</th>
                    </tr>
                </template>

                <template v-if="!noTicketsSelected || isPricePerGroupCategory">
                    <template v-if="showUniquePrice">
                        <tr>
                            <td>Ticket</td>

                            <td class="text-right" v-if="bookingGenderPrices[0].productGenderPriceComponents.length == 0">{{personVatComponents(bookingGenderPrices[0])}}</td>
                            <td class="text-right" v-if="bookingGenderPrices[0].productGenderPriceComponents.length != 0">{{personVat(bookingGenderPrices[0])}}</td>

                            <td class="text-right">
                                <div v-if="getIsLoadingCalculations && bookingGenderPrices[0].genderPriceType === 3"><loader size="small" opacity="0.2"></loader></div>
                                <div v-else>{{personPrice(bookingGenderPrices[0], true)}}</div>
                            </td>
                        </tr>
                    </template>

                    <template v-for="personType in bookingGenderPrices" v-if="personType.quantityToBook > 0 && audienceTypes &&  personType.audienceType != null">
                        <tr>
                            <td v-if="[2, 3].includes(personType.genderPriceType) || personType.genderPriceType == 1 && personType.audienceType != null">
                                <div>{{personType.quantityToBook}} x {{genderPriceObj(personType).name}}</div>
                                <div class="dark fs-small">{{genderPriceObj(personType).description}}</div>
                            </td>

                            <td class="text-right" v-if="personType.productGenderPriceComponents.length == 0">{{personVatComponents(personType)}}</td>

                            <td class="text-right" v-if="personType.productGenderPriceComponents.length != 0">{{personVat(personType)}}</td>

                            <td class="text-right">
                                <div v-if="getIsLoadingCalculations && isToShowLoading"><loader size="small" opacity="0.2"></loader></div>
                                <div v-else>{{personPrice(personType, false)}}</div>
                            </td>
                        </tr>
                    </template>
                </template>

                <template v-if="totalExtras > 0">
                    <tr>
                        <td class="font-weight-600 pt-2">Extras</td>
                    </tr>

                    <tr v-for="extra in reservation.bookingComponents" v-if="extra.quantity > 0">
                        <td>{{extra.quantity}} x {{extra.component.name + ' - ' + extra.componentPrice.name}}</td>
                        <td class="text-right white-space-nowrap">{{ extra.componentPrice.vatType }} %</td>
                        <td class="text-right">{{ formatPrice(extra.componentPrice.grossprice * extra.quantity) }} €</td>
                    </tr>
                </template>
            </table>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import { reservationsMixin } from '@/mixins/reservations'

    import Loader from '@/tools/loaders/loader1'

    export default {
        mixins: [
            reservationsMixin
        ],
        data() {
            return {
                bookingGenderPrices: null,
                tempExtras: null,
                agentChange:false
            }
        },
        props: {
            reservation: {
                type: Object
            },
            noTicketsSelected: {
                type: Boolean,
                default: false
            }
        },
        components: {
            Loader
        },
        created() {
            this.$set(this, 'tempExtras', this.reservation.bookingComponents);
            this.$set(this, 'bookingGenderPrices', this.reservation.bookingGenderPrices);
            
            // Sets attachDiscount valueType if none
            if (this.reservation.attachDiscount == null) {
                this.$set(this.reservation, 'attachDiscount', {
                    value: 0,
                    valueType: 1
                })
            }
        },
        asyncComputed: {
            async audienceTypes() {
                try {
                    let response = await axios.get('/api/settings/GetAudienceTypeList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error);
                }
            },
        },
        computed: {
            ...mapGetters([
                'getReservationCalculations',
                'getReservation',
                'getVatTypes',
                'getIsLoadingCalculations'
            ]),
            isPricePerGroupCategory() {
                return this.reservation.event.passengerSettings && this.reservation.event.passengerSettings.format === 0;
            },
            isToShowLoading() {
                const hasGenderPrices = this.bookingGenderPrices && this.bookingGenderPrices.length > 0;
                const hasPassengerSettings = this.reservation.event && this.reservation.event.passengerSettings;
                const format = hasPassengerSettings ? this.reservation.event.passengerSettings.format : null;
                
                const isCorrectFormat = format === 1 || format === 2;
                
                return hasGenderPrices && this.bookingGenderPrices[0].genderPriceType === 3 && isCorrectFormat;
            },
            showUniquePrice() {
                if (this.reservation.event.passengerSettings) {
                    return this.bookingGenderPrices[0].genderPriceType === 3 && this.reservation.event.passengerSettings.format === 0; 
                } else {
                    return this.bookingGenderPrices[0].audienceType === null;
                }
            },
            isPerOrderWithParticipants() {
                return this.reservation.bookingGenderPrices[0].genderPriceType == 1 && this.reservation.bookingGenderPrices.length > 1;
            },
            taxes() {
                return this.getVatTypes;
            },
            hasSelectedExtras() {
                if (!this.reservation.bookingComponents.length == 0) {
                    return false;
                } else {
                    let output = false;
                    for (let extra of this.reservation.bookingComponents) {
                        if (extra.quantity > 0) {
                            output = true;
                        }
                    }
                    return output;
                }
            },
            totalExtras() {
                if (!Array.isArray(this.tempExtras)) return 0;

                return this.tempExtras.reduce((sum, e) => sum + (Number(e.quantity) || 0), 0);
            }
        },
        watch: {
            // When agent change the groosprice of personType might change because of price multiplier, if agent change we need catch bookingGenderPrices of getReservationCalculations instead of this.reservation
            'reservation.agent': {
                handler(newVal, oldVal) {
                    if(oldVal.brandName && newVal.brandName && oldVal.brandName != newVal.brandName){
                        this.agentChange = true;
                    } 
                },
            }
        },
        methods: {
            ...mapActions([]),
            personVatComponents(personType) {
                return [2, 3].includes(personType.genderPriceType) ? personType.vatType + '%' : this.bookingGenderPrices[0].vatType + '%';
            },
            personVat(personType) {
                if ([2, 3].includes(personType.genderPriceType)) {
                    return this.customPerPersonTaxes(personType.productGenderPriceComponents);
                } else {
                    return '-';
                }
            },
            personPrice(personType, isFromUniquePrice) {
                if (!personType || !this.getReservationCalculations.bookingGenderPrices) {
                    return false;
                }

                let personTypeFromCalculations = personType.genderPriceType === 3 || this.agentChange ? this.getReservationCalculations.bookingGenderPrices.find(person => person.id == personType.id) : personType;
                let genderPriceType = personTypeFromCalculations.genderPriceType;
                let audienceType = personTypeFromCalculations.audienceType;
                let isPricePerCategory = this.reservation.event.passengerSettings ? this.reservation.event.passengerSettings.format !== 0 : null;

                if (isFromUniquePrice) {
                    if ((genderPriceType === 1 && audienceType == null) || (genderPriceType === 3 && !isPricePerCategory)) {
                        return this.formatPrice(personTypeFromCalculations.grossprice) + '€';
                    }
                } else {
                    if ((genderPriceType === 2 && audienceType !== null) || (genderPriceType === 3 && isPricePerCategory)) {
                        let quantityToBook = personTypeFromCalculations.quantityToBook;
                        return this.formatPrice(this.showTicketPrice(personTypeFromCalculations) * quantityToBook) + '€';
                    }
                    return '-';
                }

                return '-';
            },
            customPerPersonTaxes(row) {
                let taxes = [];
                for (let service of row) {
                    if (service.component.selectedPrice && taxes.indexOf(service.component.selectedPrice.vatType+'%') == -1) {
                        taxes.push(service.component.selectedPrice.vatType+'%');
                    }
                }
                return taxes.join(', ');
            },
        }
}
</script>

<style lang="scss" scoped>
    .priceWidth {
        width: 20%;
    }

    table {
        tr {
            th {
                font-weight: 600;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// CostList.vue?0e7910c3